/* module where all common configuration or dependencies can be found */
import axios from "axios";

export const TEMPLATE_API_ENDPOINT = process.env.VUE_APP_TEMPLATE_API_ENDPOINT;
export const CHECKLIST_API_ENDPOINT =
  process.env.VUE_APP_CHECKLIST_API_ENDPOINT;
export const EXPORTER_API_ENDPOINT = process.env.VUE_APP_EXPORTER_API_ENDPOINT;
export const USERS_API_ENDPOINT = process.env.VUE_APP_USERS_API_ENDPOINT;
export const CHECKER_API_ENDPOINT = process.env.VUE_APP_CHECKER_API_ENDPOINT;

export const TEMPLATE_CLIENT = axios.create({ baseURL: TEMPLATE_API_ENDPOINT });
export const CHECKLIST_CLIENT = axios.create({
  baseURL: CHECKLIST_API_ENDPOINT,
});
export const EXPORTER_CLIENT = axios.create({ baseURL: EXPORTER_API_ENDPOINT });
export const USERS_CLIENT = axios.create({ baseURL: USERS_API_ENDPOINT });
export const CHECKER_CLIENT = axios.create({ baseURL: CHECKER_API_ENDPOINT });

export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_GEOCODING_CLIENT = axios.create({
  baseURL: "https://maps.googleapis.com",
});

export const TemplateRevId = ({ templateId, revision }) =>
  `${templateId}.${revision}`;

export async function getCurrentPosition() {
  if (!navigator.geolocation) {
    throw new Error("We require geolocation API");
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos.coords),
      (err) => reject(err)
    );
  });
}
